import React, { forwardRef, useState, useImperativeHandle, useMemo, useEffect } from 'react';
import { List, Dropdown, Modal, message } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styles from './index.module.less';
import { deleteKnowledgeFileByDirId, queryFileDirectory } from '@/api/dictionary';
import useGlobalThemeStore from '@/store/globalTheme';
interface KnowledgeItem {
    id: string;
    name: string;
    isHome?: boolean;
    downloadAddress: string | null;
    downloadAddressAll: string | null;
    fileInfoId: string;
}

interface KnowledgeListRef {
    getList: () => Promise<void>;
}

interface KnowledgeListProps {
    domainId: string | null;
    searchValue: string;
    currentId: string;
    handleCurrentChange: (id: string, item: KnowledgeItem) => void;
    version: Record<string, any>;
    pageType: 1 | 2 | 3 | 4
}

const KnowledgeList = forwardRef<KnowledgeListRef, KnowledgeListProps>(({ version, searchValue, currentId, handleCurrentChange, pageType }, ref) => {
    const { t } = useTranslation();
    const [list, setList] = useState<KnowledgeItem[]>([]);
    const { theme: { colorPrimary } } = useGlobalThemeStore()
    const getList = async () => {
        const res = await queryFileDirectory({ dictId: version?.[0]?.dictId }) as any;
        const initList: KnowledgeItem[] = [
            {
                id: '-1',
                name: '首页',
                isHome: true,
                downloadAddress: '',
                fileInfoId: '-1',
                downloadAddressAll: ''
            }
        ];
        if (res) {
            initList.push(...res);
        }
        setList(initList);
    };

    useEffect(() => {
        if (version?.[0]?.dictId) {
            getList();
        }
    }, [version]);

    useImperativeHandle(ref, () => ({
        getList,
        // fileUrl
    }))

    // 根据搜索值过滤列表
    const filteredList = useMemo(() => {
        if (!searchValue) return list;

        return list.filter(item =>
            item.name?.toLowerCase().includes(searchValue.toLowerCase())
        );
    }, [list, searchValue]);

    const handleMenuClick = (item: KnowledgeItem) => {
        Modal.confirm({
            // title: t('ikg.confirmDelete'),
            content: `${t('ikg.confirmDeleteContent')}${item.name}？`,
            okText: t('ikg.confirm'),
            cancelText: t('ikg.cancel'),
            onOk: () => handleDelete(item),
        });
    };

    const handleDelete = async (item: KnowledgeItem) => {
        if (item.isHome) {
            return; // 不允许删除首页
        }

        await deleteKnowledgeFileByDirId({ directoryId: item.id })
        if (item.fileInfoId === currentId) {
            //删除的是当前选中的，重定位到首页
            handleCurrentChange('-1', {
                id: '-1',
                name: '首页',
                isHome: true,
                downloadAddress: '',
                fileInfoId: '-1',
                downloadAddressAll: ''
            });
        }
        message.success(t('ikg.success', { action: t('ikg.delete') }))
        getList()
    };

    const getDropdownItems = (item: KnowledgeItem) => {
        if (item.isHome) {
            return []; // 首页不显示删除选项
        }
        return [
            {
                key: 'delete',
                label: t('ikg.delete'),
            }
        ];
    };

    const onItemClick = (item: KnowledgeItem) => {
        handleCurrentChange(item.fileInfoId, item);
    }

    return (
        <div className={styles.listWrapper}>
            <List
                className={styles.knowledgeList}
                dataSource={filteredList}
                renderItem={item => (
                    <List.Item
                        className={styles.listItem}
                        //pageType 3 知识审核
                        actions={pageType === 3 ? [
                            <Dropdown
                                menu={{
                                    items: getDropdownItems(item),
                                    onClick: () => handleMenuClick(item)
                                }}
                                trigger={['hover']}
                                placement="bottom"
                            >
                                {item.isHome ? <></> : <MoreOutlined className={styles.moreIcon} />}
                            </Dropdown>
                        ] : []}
                    >
                        <div
                            className={styles.itemTitle}
                            style={{ color: currentId === item.fileInfoId ? colorPrimary : '' }}
                            onClick={() => onItemClick(item)}
                        >
                            {item.name}
                        </div>
                    </List.Item>
                )}
            />
        </div>
    );
});

export default KnowledgeList;
